// Recovered compiled webpack factory 86278. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(28140)._(r(1150));
  function a(e, t) {
    var r;
    let a = {};
    "function" == typeof e && (a.loader = e);
    let o = { ...a, ...t };
    return (0, n.default)({
      ...o,
      modules: null == (r = o.loadableGenerated) ? void 0 : r.modules,
    });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
